module.exports = __webpack_public_path__ + "img/streetsweeper_driving.c42fddf3.svg";